const P = { fill: 'none', stroke: 'currentColor', strokeWidth: 1.7, strokeLinecap: 'round', strokeLinejoin: 'round' };

const SPORT_PATHS = {
  Football: (
    <g {...P}>
      <circle cx="12" cy="12" r="8.5" />
      <path d="M12 7.4l3.2 2.3-1.2 3.8h-4l-1.2-3.8z" />
      <path d="M12 7.4V4.2M15.2 9.7l3-1.1M14 13.5l1.9 2.6M10 13.5l-1.9 2.6M8.8 9.7l-3-1.1" />
    </g>
  ),
  Rugby: (
    <g {...P}>
      <ellipse cx="12" cy="12" rx="9" ry="5.6" transform="rotate(-45 12 12)" />
      <path d="M9.5 14.5l5-5M10.8 12.2l1.2 1.2M12.2 10.8l1.2 1.2" />
    </g>
  ),
  Cricket: (
    <g {...P}>
      <circle cx="12" cy="12" r="8.5" />
      <path d="M5.5 9.2c4 1.4 9 1.4 13 0M5.5 14.8c4-1.4 9-1.4 13 0" strokeDasharray="1.6 1.6" />
    </g>
  ),
  Netball: (
    <g {...P}>
      <circle cx="12" cy="12" r="8.5" />
      <path d="M3.5 12h17M12 3.5v17M6 6l12 12M18 6L6 18" opacity="0.85" />
    </g>
  ),
  Hockey: (
    <g {...P}>
      <path d="M7 4v9a4 4 0 004 4h1M7 4H4.5M7 4h2.5" />
      <path d="M12 17a3 3 0 100 .01" />
      <circle cx="17.5" cy="6" r="1.4" fill="currentColor" stroke="none" />
    </g>
  ),
  Swimming: (
    <g {...P}>
      <path d="M3 14.5c1.6 0 1.6 1.4 3.2 1.4s1.6-1.4 3.2-1.4 1.6 1.4 3.2 1.4 1.6-1.4 3.2-1.4 1.6 1.4 3.2 1.4M3 18.5c1.6 0 1.6 1.4 3.2 1.4s1.6-1.4 3.2-1.4 1.6 1.4 3.2 1.4 1.6-1.4 3.2-1.4 1.6 1.4 3.2 1.4" />
      <circle cx="15" cy="6.5" r="1.8" />
      <path d="M5.5 11l4-2 3 1.4" />
    </g>
  ),
  Athletics: (
    <g {...P}>
      <circle cx="14" cy="5.4" r="1.9" />
      <path d="M14 8.2l-3.4 2.2.6 3.4 2.8 1.8M11.2 10.4L7 9M11.8 13.8L9 18.5M14 16.4l2.6 3" />
    </g>
  ),
  Tennis: (
    <g {...P}>
      <circle cx="12" cy="12" r="8.5" />
      <path d="M5.2 7.5C9 9 9 15 5.6 16.8M18.8 7.5C15 9 15 15 18.4 16.8" />
    </g>
  ),
  Padel: (
    <g {...P}>
      <ellipse cx="13.5" cy="8.5" rx="5.2" ry="6" transform="rotate(28 13.5 8.5)" />
      <path d="M9 13.5L5 19.5M5 19.5l-1.6-1.2M5 19.5l1.4 1.4" />
      <circle cx="12" cy="7" r="0.6" fill="currentColor" />
      <circle cx="15" cy="8" r="0.6" fill="currentColor" />
      <circle cx="13.5" cy="10.5" r="0.6" fill="currentColor" />
    </g>
  ),
};

export default function SportIcon({ sport, className }) {
  return (
    <svg viewBox="0 0 24 24" className={className}>
      {SPORT_PATHS[sport] || SPORT_PATHS.Football}
    </svg>
  );
}
